import dynamic from "next/dynamic";
import { QUESTION_TYPES } from "utils/quizUtils";

const QuizIntro = dynamic(() => import("./quiz-intro"));
const QuizStandard = dynamic(() => import("./quiz-standard"));
const QuizSpaces = dynamic(() => import("./quiz-spaces"));
const QuizImages = dynamic(() => import("./quiz-images"));
const QuizAddress = dynamic(() => import("./quiz-address"));
const QuizAccount = dynamic(() => import("./quiz-account"));
const QuizContactSlide = dynamic(() => import("./quiz-contact-slide"));

export const QuizModule = ({
  slug,
  allQuestions,
  question,
  onNext,
  onClose,
  onBack,
  numberQuestions,
  currentQuestion,
  isSubmitting,
}) => {
  const props = {
    slug,
    question,
    onNext,
    onClose,
    onBack,
    allQuestions,
    numberQuestions,
    currentQuestion,
    isSubmitting,
    key: question?._key,
  };

  switch (question?.type) {
    case QUESTION_TYPES.intro:
      return <QuizIntro {...props} />;
    case QUESTION_TYPES.standard:
      return <QuizStandard {...props} />;
    case QUESTION_TYPES.spaces:
      return <QuizSpaces {...props} />;
    case QUESTION_TYPES.images:
      return <QuizImages {...props} />;
    case QUESTION_TYPES.address:
      return <QuizAddress {...props} />;
    case QUESTION_TYPES.account:
      return <QuizAccount {...props} />;
    case QUESTION_TYPES.contactSlide:
      return <QuizContactSlide {...props} />;
    default:
      return null;
  }
};
